import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialGetCabinaState } from './cabina.state';
import { getCabina } from './cabina.utility';
import { GetCabinaGQL } from '../../_graphql/generated';

export const CabinaStore = signalStore(
  { providedIn: 'root' },

  withState(initialGetCabinaState),
  withProps(() => ({
    getter: inject(GetCabinaGQL),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getCabina(injector, store, getter),
  }))
);
